<template>
  <div class="h-full w-full flex items-center">
    <status-button
      :status="$t(`unified-offer-status.${params.status}`)"
      :color="color"
      disabled
    />
  </div>
</template>

<script>
import { UNIFIED_OFFER_STATUS_COLORS } from '@/views/Brand/Applications/Offer/_components/UnifiedOfferStatusCell/unified-offer-status-cell.constants';
import StatusButton from '@/components/StatusToggler/StatusButton.vue';

export default {
  components: { StatusButton },
  computed: {
    color() {
      return UNIFIED_OFFER_STATUS_COLORS[this.params.status];
    },
  },
};
</script>
